import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Bug, LogOut, Plus, LayoutDashboard, Terminal, Shield } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const onLogout = async () => { await logout(); nav("/login"); };

  const link = (to, label, Icon, testid) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`inline-flex items-center gap-2 px-3 py-2 uppercase text-xs tracking-[0.2em] border ${
          active ? "border-red-500 text-red-500" : "border-transparent text-neutral-400 hover:text-red-500 hover:border-red-500/50"
        }`}
      >
        <Icon size={14} /> {label}
      </Link>
    );
  };

  return (
    <header data-testid="app-nav" className="sticky top-0 z-50" style={{ background: "#050505", borderBottom: "1px solid rgba(255,42,42,0.3)" }}>
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-3 text-red-500">
          <img src="/logo.png" alt="Red Team Solutions" data-testid="nav-logo" className="h-9 w-9 object-contain" />
          <div className="flex flex-col leading-tight">
            <span className="uppercase font-bold tracking-[0.25em] text-sm text-red-500">RED TEAM SOLUTIONS</span>
            <span className="uppercase text-[0.6rem] tracking-[0.3em] text-neutral-500">// bug_tracker</span>
          </div>
        </Link>
        {user ? (
          <div className="flex items-center gap-2">
            {link("/dashboard", "Dashboard", LayoutDashboard, "nav-dashboard-link")}
            {link("/new", "Nuevo", Plus, "nav-new-bug-link")}
            {user.role === "admin" && link("/admin", "Admin", Shield, "nav-admin-link")}
            <span className="hidden md:inline text-neutral-500 text-xs uppercase tracking-[0.2em] ml-4" data-testid="nav-user-email">
              {user.company_name ? `${user.company_name} · ` : ""}{user.email}
            </span>
            <button data-testid="nav-logout-btn" id="logout-btn" onClick={onLogout} className="term-btn-ghost ml-2">
              <LogOut size={14} /> Salir
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <Link to="/login" data-testid="nav-login-link" className="term-btn-ghost">Login</Link>
            <Link to="/register" data-testid="nav-register-link" className="term-btn">Registrarse</Link>
          </div>
        )}
      </div>
    </header>
  );
}
